/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UpdateDataEntryLinkRequestFromJSON(json) {
    return UpdateDataEntryLinkRequestFromJSONTyped(json, false);
}
export function UpdateDataEntryLinkRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        versionIds: json['versionIds'],
        tagIds: !exists(json, 'tagIds') ? undefined : json['tagIds'],
        filterTagIds: json['filterTagIds'],
        intervalStart: new Date(json['intervalStart']),
        intervalEnd: new Date(json['intervalEnd']),
        duration: json['duration'],
    };
}
export function UpdateDataEntryLinkRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        versionIds: value.versionIds,
        tagIds: value.tagIds,
        filterTagIds: value.filterTagIds,
        intervalStart: value.intervalStart.toISOString().substr(0, 10),
        intervalEnd: value.intervalEnd.toISOString().substr(0, 10),
        duration: value.duration,
    };
}
